import { opd } from '../../common/wrapperComponents/ComparisonChartWrapper/constants';

let hierarchyFilter = ``;
let hierarchyInputArg = ``;

const myArg = [];

const buildComparisonChartMetricQuery = (
	metrics,
	hierarchyFilter,
	hierarchyInputArg,
	type,
	selectedView
) => {
	return `
    query ${type}($startDate: String! $endDate: String! $granularity: String! $channel: String!  ${hierarchyInputArg}) {
        
        summary: ${type}(input: {
            filter: {
                channel: $channel,
                duration: {
                    startDate: $startDate,
                    endDate: $endDate
                },
                ${hierarchyFilter}
            },
            pagination: {
                next_page_token: "${selectedView}"
            }
        }) {
            edges {
                node {
                    metrics {
                        ${metrics}
                    }
                }
            }
        }
    
        chartData: ${type}(input: {
            filter: {
                channel: $channel,
                duration: {
                    startDate: $startDate,
                    endDate: $endDate,
                    granularity: $granularity
                },
                ${hierarchyFilter}
            },
            pagination: {
                next_page_token: "${selectedView}"
            }
        }) {
            edges {
                node {
                    filters {
                        duration {
                            granularityPeriod
                        }
                    }
                    metrics {
                        ${metrics}
                    }
                }
            }
        }
    }`;
};

export const getComparisonChartQuery = (
	type,
	metricsArr,
	hierarchyType,
	selectedView
) => {
	const myArr = JSON.stringify(metricsArr)
		?.slice(1, -1)
		?.replace(/"/g, '')
		.split(',');

	// Adding TY in alias of opd and yoy metrics
	myArr?.forEach((item, idx) => {
		if (opd?.includes(item) || item?.includes('YoYPctChg')) {
			myArr[idx] = `${item}TY: ${item}`;
		} else {
			myArr[idx] = `${item}: ${item}`;
		}
	});

	if (myArr?.length > 0) {
		if (myArg?.length > 0) {
			myArg?.splice(0, myArg?.length);
		}
		myArg?.push(...myArr);
	} else if (myArg?.length > 0) {
		myArg?.splice(0, myArg?.length - 1);
	}

	if (hierarchyType === 'rhIds') {
		hierarchyFilter = `rhIds: $rhIds`;
		hierarchyInputArg = `$rhIds: [String]`;
	} else if (hierarchyType === 'wmUpcNbr') {
		hierarchyFilter = `wmUpcNbr: $wmUpcNbr`;
		hierarchyInputArg = `$wmUpcNbr: [String]`;
	} else if (hierarchyType === 'wmItemNbr') {
		hierarchyFilter = `wmItemNbr: $wmItemNbr`;
		hierarchyInputArg = `$wmItemNbr: [String]`;
	}

	const metrics = myArg?.join(`
        `);

	return buildComparisonChartMetricQuery(
		metrics,
		hierarchyFilter,
		hierarchyInputArg,
		type,
		selectedView
	);
};
